{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/post-date",
	"title": "Date",
	"category": "theme",
	"description": "Display a custom date.",
	"textdomain": "default",
	"attributes": {
		"datetime": {
			"type": "string",
			"role": "content"
		},
		"format": {
			"type": "string"
		},
		"isLink": {
			"type": "boolean",
			"default": false,
			"role": "content"
		}
	},
	"usesContext": [ "postId", "postType", "queryId" ],
	"example": {
		"viewportWidth": 350
	},
	"supports": {
		"anchor": true,
		"html": false,
		"background": {
			"gradient": true
		},
		"color": {
			"gradients": true,
			"link": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true,
				"link": true
			}
		},
		"spacing": {
			"margin": true,
			"padding": true
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"textAlign": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"interactivity": {
			"clientNavigation": true
		},
		"__experimentalBorder": {
			"radius": true,
			"color": true,
			"width": true,
			"style": true,
			"__experimentalDefaultControls": {
				"radius": true,
				"color": true,
				"width": true,
				"style": true
			}
		}
	}
}
